export default "__VITE_ASSET__ef4b9c9a__"